import { identity as parse } from 'lodash';
import React from 'react';
import { useField } from 'react-final-form';

import CTAButton from '../../../CTAButton/CTAButton';
import type { BonusTab } from '../../BonusOffer';

import { TXTWCL_Claim_your_bonus } from './ClaimBonusCode.messages.json';

interface Props {
  selectedTab?: BonusTab;
}

const ClaimBonusCode: React.FC<Props> = ({ selectedTab }) => {
  const {
    meta: { error },
    input: { value }
  } = useField('deposit.bonusCode', { subscription: { value: true, error: true }, parse });
  const disabled = !selectedTab || (selectedTab === 'ownBonus' && (error || !value));

  return <CTAButton translation={TXTWCL_Claim_your_bonus} disabled={disabled} />;
};

export default ClaimBonusCode;
